const toggle = () => {
    document.querySelectorAll('.js-index__title').forEach(head => {
        head.addEventListener('click', () => {
            const item = head.closest('.js-index__item');
            const content = item.querySelector('.js-index__content');
            const cursor = head

            // content 表示切り替え
            content.classList.toggle('is-open');

            // cursor direction 切り替え
            if (cursor) {
                const current = cursor.dataset.direction;
                cursor.dataset.direction = current === 'bottom' ? 'right' : 'bottom';
            }
        });
    });
}


const smoothScrollWithHeader = () => {
    const header = document.querySelector('.l-header');
    let headerHeight = header ? header.offsetHeight : 0;

    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('.js-scroll');
        if (!trigger) return;

        const targetId =
            trigger.dataset.target ||
            trigger.getAttribute('href');

        if (!targetId || !targetId.startsWith('#')) return;

        const target = document.querySelector(targetId);
        if (!target) return;

        e.preventDefault();

        const targetPosition =
            target.getBoundingClientRect().top +
            window.pageYOffset -
            headerHeight;

        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });

    });
};
const column = () => {
    toggle();
    smoothScrollWithHeader();
}
export default column;
